export function isInt(value) {
    return (
        !isNaN(value) &&
        // eslint-disable-next-line
        parseInt(Number(value)) == value &&
        !isNaN(parseInt(value, 10))
    );
}

export const isset = (param) => typeof param !== 'undefined' && param !== null;

export const issetInputValue = (param) =>
    typeof param !== 'undefined' && param !== null && param !== '';

// export const numberFormatter = new Intl.NumberFormat("nl-NL", {
//   style: "decimal",
//   minimumFractionDigits: 2,
// });

const baseNumberFormatter = (value, options = {}, customGroup = ' ') => {
    const formatter = new Intl.NumberFormat('en', options);
    return formatter
        .formatToParts(value)
        .map((part) => (part.type === 'group' ? customGroup : part.value))
        .join('');
};

export const numberFormatter = {
    format: (value) =>
        baseNumberFormatter(
            value,
            {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            ' '
        ),
};

/**
 * Rounds to the given number of significant digits, but keeps
 * all before the decimals separator
 * 54.0123 -> 54.0, but
 * 54123.678 -> 54124
 * @param {number} value
 * @param {number} significantDigits
 * @returns {string}
 */
export const decimalRoundSignificant = (value, significantDigits = 2) => {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
        return '';
    }

    const absoluteValue = Math.abs(numericValue);

    if (absoluteValue === 0) {
        return baseNumberFormatter(0, { style: 'decimal' }, ' ');
    }

    // For values >= 1, keep all integer digits and only allow remaining precision in decimals.
    if (absoluteValue >= 1) {
        const integerDigits = Math.floor(Math.log10(absoluteValue)) + 1;
        const decimals = Math.max(0, significantDigits - integerDigits);

        if (decimals === 0) {
            const roundedValue = Math.round(numericValue);

            return baseNumberFormatter(
                roundedValue,
                {
                    style: 'decimal',
                    maximumFractionDigits: 0,
                },
                ' '
            );
        }

        const factor = 10 ** decimals;
        const roundedValue = Math.round(numericValue * factor) / factor;

        return baseNumberFormatter(
            roundedValue,
            {
                style: 'decimal',
                maximumFractionDigits: decimals,
                minimumFractionDigits: decimals,
            },
            ' '
        );
    }

    return baseNumberFormatter(
        numericValue,
        {
            style: 'decimal',
            maximumSignificantDigits: significantDigits,
        },
        ' '
    );
};

export const roundSignificant = (value, significantDigits = 2) => {
    return baseNumberFormatter(
        value,
        {
            style: 'decimal',
            maximumSignificantDigits: significantDigits,
        },
        ' '
    );
};

export const roundDecimal = (value, decimals = 0) => {
    return baseNumberFormatter(
        value,
        {
            style: 'decimal',
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals,
        },
        ' '
    );
};

export const formatObjectValues = (obj) =>
    Object.entries(obj).reduce((prev, [key, value]) => {
        return {
            ...prev,
            [key]: isset(value) ? numberFormatter.format(value) : '',
        };
    }, {});

export const formatObjectValuesDeep1 = (obj) =>
    Object.entries(obj).reduce((prev, [key, value]) => {
        return {
            ...prev,
            [key]: isset(value) ? formatObjectValues(value) : value,
        };
    }, {});
